module.exports = __webpack_public_path__ + "static/media/sarah.208123d6.png";